var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.layout || "div",{tag:"component"},[_c('router-view')],1),(_vm.portalConfig.trackingID)?_c('CookieBanner'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }